export enum NavbarActionEnum {
  NOTIFICATIONS = 'notifications',
  SETTINGS = 'settings'
}
